<template>
  <div class="row mr-3 mb-3" style="min-width: 400px; max-width: 800px">
    <div class="col-md-12">
      <div class="card card-default border-card rounded">
        <div class="card-header separator top-left top-right mb-3">
          <div class="card-title text-black hint-text">
            <h4 class="fs-12 all-caps text-danger bold">
              Trend #{{ rank }}
            </h4>
          </div>
        </div>
        <div class="card-body p-t-40 mt-5">
          <div class="row">
            <div class="col-sm-12">
              <p class="no-margin p-b-5 semi-bold text-center">
                {{ title }}
              </p>
              <p class="text-center">
                {{ limitString(content, 40) }}
              </p>
            </div>
          </div>
          <a
            class="pull-right m-b-10"
            style="cursor: pointer; color: #14a1c8 !important"
            @click="clickBerita()"
          >
            Lihat Berita
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gp from "@/plugins/generalPlugins.js";

export default {
  name: "new_strend_item",
  props: {
    title: String,
    content: String,
    rank: Number,
    date: Array,
    ids: Array,
  },
  methods: {
    limitString: function (text, count) {
      return gp.limitString(text, count);
    },
    clickBerita: function () {
      this.$parent.viewStream(this.ids, this.date, this.title, this.content);
    },
  },
};
</script>

<style scoped>
.border-card {
  border: 0.5px solid #bbb6b668;
}
</style>
